// English translations for AHP application
export const en = {
  // ========== LOGIN ==========
  login: {
    title: "Login",
    password: "Password",
    loginPlaceholder: "Login...",
    passwordPlaceholder: "Password...",
    button: "Log in",
    selectLanguage: "Language"
  },

  // ========== TOASTS / NOTIFICATIONS ==========
  toasts: {
    loginSuccess: "Successfully logged in",
    loginError: "Login or password is incorrect"
  },

  // ========== MENU ==========
  menu: {
    title: "AHP Pairwise Comparison Method",
    logout: "Logout"
  },

  // ========== FORMS / FORMS ==========
  forms: {
    // Default page content (HTML) — used when a study page has empty text
    startPage: `<p>You are about to start the study. We will ask you to determine the importance of individual benefits provided by trees and shrubs. Before proceeding, make sure you have familiarized yourself with the <a href="https://docs.google.com/document/d/1he9XOa-yzWXOpTl3ep7PAr1c2dLCD1kzdHQtviV16XY/edit?usp=sharing" target="_blank" rel="noopener noreferrer">general study information</a> and <a href="https://youtu.be/MUqhubzGTJM" target="_blank" rel="noopener noreferrer">instructions</a>.</p><p>The study consists of 4 pages with comparisons. The next pages are activated after clicking the "next" button. You can also go back to the previous page at any time ("back" button). In the middle, we suggest taking a short break. Please do not forget to press the "send" button after completing the questionnaire. In case of problems, please contact Patrycja Przewoźna at phone number <strong>608172288</strong>.</p>`,
    middlePage: `<p>It is not good to make too many decisions at once. Since you are exactly in the middle of the study, we suggest taking at least a short break before filling out the second part of the questionnaire.</p>`,
    endPage: `<p>Do you want to finish the study and send the results? If yes, press "send", if you want to correct something, press "back".</p>`,

    // Validation messages
    validation: {
      maxInconsistency: "Value causing the greatest inconsistency!",
      answersInconsistent: "Answers are not consistent!",
      answersConsistent: "Answers are consistent"
    },
    mark: "Category"
  },

  // ========== BUTTONS ==========
  buttons: {
    back: "Back",
    next: "Next",
    send: "Send",
    check: "CHECK",
    logout: "Logout"
  },

  // ========== THANKS ==========
  thanks: {
    message: "Thank you for your time",
    backToLogin: "Return to login panel"
  },

  // ========== CHECK COMPONENT ==========
  check: {
    selectPerson: "Select person",
    vectorsAndCI: "Vectors and CI",
    saatyMatrix: "Saaty Matrix",
    transposedSaatyMatrix: "Transposed Saaty Matrix",
    triangularMatrix: "Triangular Matrix"
  }
};

export default en;
